var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSdiImportance = function SvgSdiImportance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SDI-Importance_svg__SDI-Importance_svg__clip0_772_29681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.665 1.333a2 2 0 012 2v9.334a2 2 0 01-2 2H3.332a2 2 0 01-2-2V3.333a2 2 0 012-2h9.333zM8 4.668l-.06.003-.039.004-.079.017-.07.023-.075.036-.074.048a.672.672 0 00-.075.064L4.861 7.53l-.056.063a.667.667 0 00.056.88l.062.055a.667.667 0 00.88-.055l1.529-1.528v3.723l.005.078a.666.666 0 001.328-.078V6.944l1.529 1.528.063.055a.667.667 0 00.88-.998L8.47 4.862l-.055-.048-.069-.05-.065-.035-.074-.029-.074-.02-.084-.011-.05-.002z",
    fill: "#DB2A4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SDI-Importance_svg__SDI-Importance_svg__clip0_772_29681"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSdiImportance;